export default class Theme {
	id = '';
	name = '';
	type = '';
	/** @type {Map<String, boolean>} */
	storefronts = new Map();

	constructor(theme) {
		if (theme) {
			this.id = theme.id;
			this.name = theme.name;
			this.type = theme.type;
			this.storefronts = new Map(theme.storefronts.map(storefront => [storefront, true]));
		}
	}
}